import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/messaging';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyC0LqcLlZpAVJFkbdeKzXUEMllAKD5VOKU",
  authDomain: "majo-cobos.firebaseapp.com",
  projectId: "majo-cobos",
  storageBucket: "majo-cobos.appspot.com",
  messagingSenderId: "686827632023",
  appId: "1:686827632023:web:f635275f1b5e457145c0d2",
  measurementId: "G-ERQRXKZ2E5"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
firebase.firestore();
firebase.functions();
// firebase.messaging();

const storage = firebase.storage();

export { storage, firebase as default };
